import ApiClient from '@src/lib/api_client'
import EmojiData from '@src/routes/club/emoji/types/EmojiData'
import { API } from '@src/lib/api_path'

type EmojiResponse = {
  'id': number,
  'name': string,
  'url': string
}

type EmojiCategoryResponse = {
  'category_type': string,
  'selected': EmojiResponse,
  'available': EmojiResponse[]
}
type EmojiCategoriesResponse = {
  'smiley_categories': EmojiCategoryResponse[]
}

export class EmojiService {

  apiClient: ApiClient = new ApiClient()

  async getEmojis (): Promise<EmojiData> {
    return this.apiClient.get<EmojiCategoriesResponse>(API.TRAINERS_API.EMOJIS).then(
      response => {
        const smileyCategories = response.smiley_categories
        const emojisData = new EmojiData()
        for (let i = 0; i < smileyCategories.length; i += 1) {
          emojisData[smileyCategories[i].category_type].selected = smileyCategories[i].selected
          emojisData[smileyCategories[i].category_type].available = smileyCategories[i].available
        }

        return emojisData
      }
    ).catch(error => {
      console.error('failed to retrieve workouts', error)
      return Promise.reject(error)
    })
  }
}
